module.exports = __webpack_public_path__ + "img/np_pin_warning.e5806af4.svg";